const INFO = {
	main: {
		title: "Lunexa Labs",
		email: "admin@lunexalabs.com",
		logo: "/logo-64.webp",
		logoSrcSet: "/logo-64.webp 64w, /logo-128.webp 128w",
	},

	socials: {
		twitter: "",
		github: "",
		linkedin: "",
		instagram: "",
	},

	homepage: {
		eyebrow: "Independent product studio",
		title: "Focused software, thoughtfully built.",
		description:
			"Lunexa Labs designs and ships mobile apps, web software, games, and digital tools across product discovery, UX, engineering, QA, release, and ongoing support.",
	},

	about: {
		title: "A focused product studio with a wide range.",
		description:
			"Lunexa Labs designs, engineers, and supports focused digital products across the software development lifecycle—from discovery and UX to implementation, release, and improvement.",
	},

	projects: [
		{
			title: "Touch Count", shortTitle: "Touch Count", slug: "touch-point",
			landingPath: "/apps/touch-point", platform: "Android · iOS · Coming soon",
			category: "Number puzzle", theme: "touch-count",
			tagline: "Small numbers. Big connections.",
			description: "Connect numbered tiles, clear groups, and find your next little aha in Endless mode or 120 Adventure puzzles.",
			logo: "/products/touch-count/icon-256.webp",
			logoSrcSet: "/products/touch-count/icon-128.webp 128w, /products/touch-count/icon-256.webp 256w",
			facts: ["120 Adventure puzzles", "Endless mode", "Local progress"],
		},
		{
			title: "Geo Quiz: Guess the Flag",
			shortTitle: "Geo Quiz",
			slug: "geo-master-quest",
			landingPath: "/apps/geo-quiz-guess-the-flag/",
			platform: "iOS · Android · macOS",
			category: "Learning game",
			theme: "geo",
			tagline: "Guess the flag. Learn the world.",
			description:
				"Guess the flag, learn capitals and recognise maps in a geography quiz for iPhone, iPad and Android.",
			logo: "/products/geo/app-logo-256.webp",
			logoSrcSet:
				"/products/geo/app-logo-128.webp 128w, /products/geo/app-logo-256.webp 256w",
			appId: {
				playStore: "com.lunexalabs.geoquiz.guesstheflag",
				appStore: "id6497168919",
			},
			facts: ["Daily challenge", "Adventure levels", "7 quiz modes"],
			features: [
				{
					title: "Adventure mode",
					description:
						"Unlock chapters and turn geography practice into visible progress.",
				},
				{
					title: "Quick play",
					description:
						"Jump into flags, capitals, maps, monuments, or country rounds in seconds.",
				},
				{
					title: "Daily challenge",
					description:
						"A fresh reason to return, with focused questions, rewards, and streaks.",
				},
			],
		},
		{
			title: "Plotto",
			shortTitle: "Plotto",
			slug: "plotto",
			landingPath: "/apps/plotto",
			platform: "iOS · Android",
			category: "Interactive stories",
			theme: "plotto",
			tagline: "Your next story begins with one strange choice.",
			description:
				"Play a short daily quest, choose what happens next, and build your legend across ten very different story worlds.",
			logo: "/products/plotto/logo.png",
			appId: {
				playStore: "com.lunexalabs.plotto",
				appStore: "id6749907263",
			},
			facts: ["10 story worlds", "Daily quests", "Branching outcomes"],
			features: [
				{
					title: "A story-sized ritual",
					description:
						"Finish a complete adventure in the space of a coffee break.",
				},
				{
					title: "Choices with consequences",
					description:
						"Replay quests to find the branches and endings you left behind.",
				},
				{
					title: "A growing legend",
					description:
						"Collect XP, streaks, traits, titles, and badges shaped by how you play.",
				},
			],
		},
		{
			title: "QuietVault",
			shortTitle: "QuietVault",
			slug: "quiet-vault",
			externalUrl: "https://quietvaultapp.com/",
			platform: "Android · iOS · macOS",
			category: "Private file vault",
			theme: "quiet",
			tagline: "Lock private files. Keep control.",
			description:
				"An encrypted, local-first home for documents, photos, videos, IDs, receipts, and scans—without a hosted vault.",
			logo: "/quietvault.jpg",
		},
		{
			title: "Lunexa Messages",
			shortTitle: "Messages",
			slug: "lunexa-messages",
			externalUrl: "https://lunexamessages.com/",
			platform: "Android",
			category: "Private SMS + insights",
			theme: "messages",
			tagline: "Understand your money. Own your messages.",
			description:
				"A modern private SMS app with on-device Money Insights, scheduling, reminders, backup, and protected exports.",
			logo: "/lunexa-messages-256.webp",
			logoSrcSet:
				"/lunexa-messages-128.webp 128w, /lunexa-messages-256.webp 256w",
		},
		{
			title: "Life Vault",
			shortTitle: "Life Vault",
			slug: "life-vault",
			externalUrl: "https://lifevaultapp.co/",
			platform: "iOS · Android · Desktop",
			category: "Family readiness",
			theme: "lifevault",
			tagline: "Important information, ready before it becomes urgent.",
			description:
				"Turns scattered family records into a readiness plan with emergency packs, review reminders, recovery points, and practical handover guidance.",
			logo: "/products/lifevault/logo-256.webp",
			logoSrcSet:
				"/products/lifevault/logo-128.webp 128w, /products/lifevault/logo-256.webp 256w",
		},
		{
			title: "Lunexa Elder Care",
			shortTitle: "Elder Care",
			slug: "elder-care",
			externalUrl: "https://lunexaeldercare.com/",
			platform: "iOS · Android",
			category: "Family care companion",
			theme: "eldercare",
			tagline: "Care details ready. Family life still human.",
			description:
				"Coordinates medicines, appointments, emergency cards, wellness routines, home safety, and caregiver handoffs without making care feel clinical.",
			logo: "/products/eldercare/logo-256.webp",
			logoSrcSet:
				"/products/eldercare/logo-128.webp 128w, /products/eldercare/logo-256.webp 256w",
		},
		{
			title: "Echo Match",
			shortTitle: "Echo Match",
			slug: "echo-match",
			landingPath: "/apps/echo-match",
			platform: "iOS · Android",
			category: "Memory game",
			theme: "echo",
			tagline: "Listen, remember, repeat.",
			description:
				"A clean color-pattern memory game with responsive feedback, quick sessions, and a difficulty curve that grows with you.",
			logo: "/simon_says.jpg",
			appId: {
				playStore: "com.lunexalabs.simonsays",
				appStore: "id6745681978",
			},
			facts: [
				"Quick sessions",
				"Pattern memory",
				"Progressive challenge",
			],
			features: [
				{
					title: "Clear feedback",
					description:
						"Color, sound, and motion make every sequence easy to read and satisfying to repeat.",
				},
				{
					title: "Your pace",
					description:
						"Choose a short focus break or settle in for a longer streak.",
				},
				{
					title: "Real progression",
					description:
						"The challenge rises naturally as your recall and confidence improve.",
				},
			],
		},
	],
};

export default INFO;
